import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  businessCategoriesList: null,
  error: null,
};

export const miscSlice = createSlice({
  name: "misc",
  initialState,
  reducers: {
    businessCategories: (state) => {
      state.loading = true;
      state.error = null;
      state.businessCategoriesList = null;
    },
    businessCategoriesSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.businessCategoriesList = action.payload;
    },
    businessCategoriesError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.businessCategoriesList = null;
    },
  },
});

export default miscSlice;
